import { ApiResponse } from '@/models/ApiResponse';
import { ReportFile } from '@/models/ReportFile';
import downloadS3File from '@/utils/downloadS3File';

import { getType } from 'typesafe-actions';

import {
  runDealContingentActions,
  runRatesDealContingentActions,
  saveUserWidgetDealContingentActions,
} from './actions';
import {
  DealContingentActionType,
  DealContingentRunState,
  DealContingentState,
} from './types';

const initialRunState: DealContingentRunState = {
  loading: false,
  error: null,
  result: null,
};

const initialDealContingentState: DealContingentState = {
  saveInputs: {
    loading: false,
    error: null,
  },
  run: initialRunState,
  ratesRun: initialRunState,
};

// Both reports come back as the same download envelope, so the file is pulled
// off the response in one place.
const runSucceeded = (
  result: ApiResponse<ReportFile>,
): DealContingentRunState => {
  const { file_name, file_s3_url } = result.data;
  if (file_s3_url && file_name) {
    downloadS3File(file_s3_url, file_name);
  }

  return { loading: false, error: null, result };
};

const dealContingentReducer = (
  state: DealContingentState = initialDealContingentState,
  action: DealContingentActionType,
): DealContingentState => {
  switch (action.type) {
    case getType(saveUserWidgetDealContingentActions.request):
      return {
        ...state,
        saveInputs: {
          loading: true,
          error: null,
        },
      };

    case getType(saveUserWidgetDealContingentActions.success):
      return {
        ...state,
        saveInputs: {
          loading: false,
          error: null,
        },
      };

    case getType(saveUserWidgetDealContingentActions.failure):
      return {
        ...state,
        saveInputs: {
          loading: false,
          error: action.payload,
        },
      };

    case getType(runDealContingentActions.request):
      return {
        ...state,
        run: {
          ...state.run,
          loading: true,
          error: null,
        },
      };

    case getType(runDealContingentActions.success):
      return {
        ...state,
        run: runSucceeded(action.payload),
      };

    case getType(runDealContingentActions.failure):
      return {
        ...state,
        run: {
          loading: false,
          error: action.payload,
          result: null,
        },
      };

    case getType(runRatesDealContingentActions.request):
      return {
        ...state,
        ratesRun: {
          ...state.ratesRun,
          loading: true,
          error: null,
        },
      };

    case getType(runRatesDealContingentActions.success):
      return {
        ...state,
        ratesRun: runSucceeded(action.payload),
      };

    case getType(runRatesDealContingentActions.failure):
      return {
        ...state,
        ratesRun: {
          loading: false,
          error: action.payload,
          result: null,
        },
      };

    default:
      return state;
  }
};

export default dealContingentReducer;
